import { StorageProvider } from '../StorageProvider';

export class TrackingStorageProvider {
    static inject = () => [StorageProvider];
    constructor(private storageProvider: StorageProvider){}

    // NOTE: old storage key OPT_OUT_TRACKING is deprecated and ignored
    optOutOfTracking = this.storageProvider.getBooleanProvider('OPT_OUT_TRACKING_V2', { envNeutral: true, userNeutral: true, storageType: 'localStorage' });
}
